'use client';

type RouteFailureScreenProps = {
  chunkError: boolean;
  title: string;
  message: string;
  onReload: () => void;
  onBack: () => void;
};

/**
 * Inline styles on purpose. A missing CSS chunk must not hide this screen.
 */
export function RouteFailureScreen({
  chunkError,
  title,
  message,
  onReload,
  onBack,
}: RouteFailureScreenProps) {
  return (
    <div
      role="alert"
      data-failure={chunkError ? 'chunk' : 'route'}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: '#F7F3E9',
        color: '#1B2A24',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 16,
          border: '1px solid rgba(20,30,25,0.12)',
          background: '#FFFFFF',
          padding: 32,
          textAlign: 'center',
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        }}
      >
        <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.25, fontWeight: 700 }}>
          {title}
        </h1>
        <p style={{ margin: '16px 0 0', fontSize: 16, lineHeight: 1.6, color: '#3B4A43' }}>
          {message}
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 12, marginTop: 24 }}>
          <button
            type="button"
            onClick={onReload}
            style={{
              minHeight: 44,
              border: 0,
              borderRadius: 12,
              background: '#1F3B2E',
              color: '#FFFFFF',
              padding: '10px 18px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
          <button
            type="button"
            onClick={onBack}
            style={{
              minHeight: 44,
              borderRadius: 12,
              border: '1px solid #D6D0C0',
              background: '#FFFFFF',
              color: '#1B2A24',
              padding: '10px 18px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
